
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/[id]",
      function () {
        return require("private-next-pages/business/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/[id]"])
      });
    }
  